<a [routerLink]="route" class="link">
  <ng-content></ng-content>
</a>
